import { downloadFile } from "./downloadFile";
import { showToast } from "./showToast";

export const requestWithToast = async (endpoint, params) => {
  try {
    let { data } = await endpoint(params);

    showToast(data.message ?? "Action was successful");
  } catch (err) {
    showToast(err.response?.error ?? "Something went wrong");
    console.log(err);
  }
};

export const requestWithDownload = async (endpoint, fileName) => {
  try {
    let res = await endpoint();

    downloadFile({ data: res.data, fileName: `${fileName}.csv`, fileType: "text/csv" });
  } catch (err) {
    console.log(err);
  }
};
